import React from "react";
import { useNavigate } from "react-router-dom";

const WorkersCompPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .wc-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #ecfeff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .wc-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .wc-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(45, 212, 191, 0.28), rgba(56, 189, 248, 0.12));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.4fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .wc-hero {
            grid-template-columns: 1fr;
          }
        }

        .wc-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(45, 212, 191, 0.2);
          color: #0f766e;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .wc-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #14b8a6;
        }

        .wc-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .wc-subtitle {
          font-size: 15px;
          max-width: 580px;
          color: #374151;
        }

        .wc-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .wc-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .wc-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .wc-btnPrimary,
        .wc-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .wc-btnPrimary {
          background: #14b8a6;
          color: #022c22;
          box-shadow: 0 10px 24px rgba(20, 184, 166, 0.4);
        }

        .wc-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(20, 184, 166, 0.55);
        }

        .wc-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .wc-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .wc-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .wc-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .wc-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.32);
        }

        .wc-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .wc-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .wc-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .wc-flexCol {
          flex: 1 1 260px;
        }

        .wc-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .wc-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .wc-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .wc-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #14b8a6;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .wc-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .wc-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .wc-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .wc-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TWO-COLUMN GRID SECTION */
        .wc-twoColGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .wc-pillBox {
          padding: 14px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .wc-pillTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .wc-pillText {
          font-size: 13px;
          color: #4b5563;
        }

        /* TIMELINE */
        .wc-timeline {
          display: grid;
          gap: 10px;
          margin-top: 14px;
        }

        .wc-step {
          display: flex;
          gap: 10px;
          align-items: flex-start;
        }

        .wc-stepNumber {
          width: 22px;
          height: 22px;
          border-radius: 999px;
          background: #14b8a6;
          color: #022c22;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 700;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .wc-stepBody {
          font-size: 13px;
          color: #111827;
        }

        .wc-stepBody strong {
          display: block;
          margin-bottom: 2px;
        }

        /* BANNER */
        .wc-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .wc-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .wc-banner img {
            height: 270px;
          }
        }

        .wc-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.9), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .wc-bannerText {
          color: #ecfeff;
          font-size: 15px;
          max-width: 460px;
        }

        .wc-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .wc-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .wc-bannerButtons .primary {
          background: #14b8a6;
          color: #022c22;
        }

        .wc-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .wc-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .wc-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .wc-bottomText strong {
          color: #a7f3d0;
        }

        .wc-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .wc-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .wc-bottomActions .primary {
          background: #14b8a6;
          color: #022c22;
        }

        .wc-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .wc-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="wc-page">
        <div className="wc-inner">
          {/* HERO */}
          <section className="wc-hero">
            <div>
              <div className="wc-tag">
                <span className="wc-tagDot" />
                Workers’ Compensation · Physical Therapy
              </div>
              <h1 className="wc-title">
                If you were hurt at work, workers’ comp physical therapy helps you recover while the claim is being handled.
              </h1>
              <p className="wc-subtitle">
                Workers’ compensation is designed so job-related injuries can be evaluated and treated, including
                physical therapy—while your employer and insurer work through the claim. We focus on your movement,
                pain levels, and getting you back to safe activity.
              </p>

              <div className="wc-chips">
                <span className="wc-chip">Lifting or bending injuries</span>
                <span className="wc-chip">Repetitive strain</span>
                <span className="wc-chip">Falls & slips at work</span>
                <span className="wc-chip">Neck, back, or shoulder pain</span>
              </div>

              <div className="wc-ctaRow">
                <button
                  className="wc-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a workers’ comp visit →
                </button>
                <button
                  className="wc-btnSecondary"
                  onClick={() => navigate("/contact")}
                >
                  Ask about workers’ comp PT
                </button>
              </div>
            </div>

            <div className="wc-heroImgWrap">
              <img
                src="/content/workers-comp-pt/workerscomp_hero.png"
                alt="Therapist and patient discussing work injury and treatment plan"
                className="wc-heroImg"
              />
            </div>
          </section>

          {/* WHAT IS WORKERS’ COMP + PT */}
          <section className="wc-stripe">
            <div className="wc-flexRow">
              <div className="wc-flexCol">
                <div className="wc-sectionTitle">What is workers’ compensation physical therapy?</div>
                <p className="wc-sectionSubtitle">
                  Workers’ compensation is a type of insurance that may cover medical care for job-related injuries.
                  Physical therapy is often part of that care—especially when pain or stiffness affects how you lift,
                  bend, stand, or do your usual tasks. Exact rules and approvals depend on your policy and local laws.
                </p>

                <ul className="wc-list">
                  <li>
                    <span className="wc-bullet" />
                    <span>
                      You were injured while performing your work duties and now have pain or limited movement.
                    </span>
                  </li>
                  <li>
                    <span className="wc-bullet" />
                    <span>
                      A doctor, occupational health provider, or employer suggested physical therapy through workers’ comp.
                    </span>
                  </li>
                  <li>
                    <span className="wc-bullet" />
                    <span>
                      You want to know how PT fits into your overall workers’ comp case while staying within approvals.
                    </span>
                  </li>
                </ul>

                <div className="wc-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="wc-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule an evaluation →
                  </button>
                </div>
              </div>

              <div className="wc-flexCol">
                <img
                  src="/content/workers-comp-pt/workerscomp_paperwork.png"
                  alt="Staff member going over workers' compensation paperwork with patient"
                  className="wc-img"
                />
              </div>
            </div>
          </section>

          {/* COMMON WORK INJURIES */}
          <section className="wc-stripe">
            <div className="wc-sectionTitle">Common work injuries we see in PT</div>
            <p className="wc-sectionSubtitle">
              Work looks different for everyone—desk jobs, healthcare, warehouses, construction, retail—but many
              people share similar pain patterns after an injury.
            </p>

            <div className="wc-cardGrid">
              <div className="wc-card">
                <div className="wc-cardTitle">Lifting & bending injuries</div>
                <div className="wc-cardText">
                  Back or hip pain after lifting boxes, patients, equipment, or repeatedly bending or twisting.
                </div>
              </div>
              <div className="wc-card">
                <div className="wc-cardTitle">Repetitive strain</div>
                <div className="wc-cardText">
                  Shoulder, elbow, or wrist discomfort from repeated reaching, typing, scanning, or tool use.
                </div>
              </div>
              <div className="wc-card">
                <div className="wc-cardTitle">Slips, trips, and falls</div>
                <div className="wc-cardText">
                  Ankle, knee, or hip injuries from slipping on wet floors, uneven surfaces, or stairs.
                </div>
              </div>
              <div className="wc-card">
                <div className="wc-cardTitle">Prolonged standing or sitting</div>
                <div className="wc-cardText">
                  Neck, shoulder, or low back stiffness from long hours at a desk, machine, counter, or exam room.
                </div>
              </div>
            </div>
          </section>

          {/* HOW THE PROCESS USUALLY WORKS */}
          <section className="wc-stripe">
            <div className="wc-flexRow">
              <div className="wc-flexCol">
                <img
                  src="/content/workers-comp-pt/workerscomp_evaluation.png"
                  alt="Physical therapist performing a gentle work-related movement evaluation"
                  className="wc-img"
                />
              </div>

              <div className="wc-flexCol">
                <div className="wc-sectionTitle">
                  How a workers’ comp PT plan usually fits into your case
                </div>
                <p className="wc-sectionSubtitle">
                  We focus on your recovery and function. We don&apos;t make legal decisions or guarantee approvals,
                  but we do help keep treatment organized and clearly documented for your providers and insurer.
                </p>

                <div className="wc-timeline">
                  <div className="wc-step">
                    <div className="wc-stepNumber">1</div>
                    <div className="wc-stepBody">
                      <strong>Referral & claim details</strong>
                      We gather key information: claim or case number (if assigned), referring provider, employer, and
                      any limits or authorizations we are aware of.
                    </div>
                  </div>

                  <div className="wc-step">
                    <div className="wc-stepNumber">2</div>
                    <div className="wc-stepBody">
                      <strong>Work-focused evaluation</strong>
                      A physical therapist listens to how you were injured, what your job involves, and checks your
                      motion, strength, and comfort with work-like tasks.
                    </div>
                  </div>

                  <div className="wc-step">
                    <div className="wc-stepNumber">3</div>
                    <div className="wc-stepBody">
                      <strong>Plan built around your role</strong>
                      We create a plan aimed at your actual job demands—whether that means lifting, standing,
                      walking, or a lot of computer work.
                    </div>
                  </div>

                  <div className="wc-step">
                    <div className="wc-stepNumber">4</div>
                    <div className="wc-stepBody">
                      <strong>Updates for your providers</strong>
                      With your permission and any required forms, we can send progress notes to your treating provider
                      and, when appropriate, to your adjuster or case manager.
                    </div>
                  </div>
                </div>

                <div className="wc-ctaRow" style={{ marginTop: "16px" }}>
                  <button
                    className="wc-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a workers’ comp evaluation →
                  </button>
                  <button
                    className="wc-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Ask about coverage & approvals
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS YOUR BODY */}
          <section className="wc-stripe">
            <div className="wc-flexRow">
              <div className="wc-flexCol">
                <div className="wc-sectionTitle">
                  How physical therapy supports recovery from work injuries
                </div>
                <p className="wc-sectionSubtitle">
                  Our job is to help your body heal, move, and tolerate work again—as safely and steadily as possible.
                </p>

                <div className="wc-twoColGrid">
                  <div className="wc-pillBox">
                    <div className="wc-pillTitle">Reduce pain & muscle guarding</div>
                    <div className="wc-pillText">
                      Hands-on care, gentle movement, and positions that let irritated tissues calm down.
                    </div>
                  </div>
                  <div className="wc-pillBox">
                    <div className="wc-pillTitle">Restore comfortable motion</div>
                    <div className="wc-pillText">
                      Gradual stretching and mobility work for joints and muscles affected by the injury.
                    </div>
                  </div>
                  <div className="wc-pillBox">
                    <div className="wc-pillTitle">Rebuild strength & endurance</div>
                    <div className="wc-pillText">
                      Targeted strengthening for the areas you use most at work—back, shoulders, legs, or core.
                    </div>
                  </div>
                  <div className="wc-pillBox">
                    <div className="wc-pillTitle">Practice safer movement</div>
                    <div className="wc-pillText">
                      Coaching on lifting, reaching, or workstation setup so you can return to tasks with more confidence.
                    </div>
                  </div>
                </div>

                <div className="wc-ctaRow" style={{ marginTop: "18px" }}>
                  <button
                    className="wc-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a visit →
                  </button>
                </div>
              </div>

              <div className="wc-flexCol">
                <img
                  src="/content/workers-comp-pt/workerscomp_treatment.png"
                  alt="Therapist guiding work-related strengthening and movement"
                  className="wc-img"
                />
              </div>
            </div>
          </section>

          {/* FAQ / QUICK CLARITY */}
          <section className="wc-stripe">
            <div className="wc-sectionTitle">Common workers’ comp questions</div>
            <p className="wc-sectionSubtitle">
              These are general themes we hear often. This is not legal advice, insurance advice, or a guarantee of coverage.
              Always confirm details with your employer, insurer, case manager, or attorney.
            </p>

            <div className="wc-twoColGrid">
              <div className="wc-pillBox">
                <div className="wc-pillTitle">Do I need authorization to start PT?</div>
                <div className="wc-pillText">
                  Many workers’ comp carriers require a referral and authorization. Our front desk can tell you what we
                  typically see, but final answers always come from your insurer or case manager.
                </div>
              </div>
              <div className="wc-pillBox">
                <div className="wc-pillTitle">Will PT visits affect my case?</div>
                <div className="wc-pillText">
                  PT creates a record of your symptoms, function, and progress. We document clinically; questions about how
                  that affects your specific case are best for your legal or insurance team.
                </div>
              </div>
              <div className="wc-pillBox">
                <div className="wc-pillTitle">Can you help with work restrictions?</div>
                <div className="wc-pillText">
                  We can share objective findings and functional notes with your treating provider, who usually writes the
                  official work restrictions or return-to-work forms.
                </div>
              </div>
              <div className="wc-pillBox">
                <div className="wc-pillTitle">What will I owe out of pocket?</div>
                <div className="wc-pillText">
                  Responsibility depends on approvals, policy limits, and local rules. Our staff can review what we see on
                  our end, and we always recommend speaking directly with your adjuster about benefits.
                </div>
              </div>
            </div>

            <div className="wc-ctaRow" style={{ marginTop: "18px" }}>
              <button
                className="wc-btnPrimary"
                onClick={() => navigate("/contact")}
              >
                Message us about your work injury →
              </button>
              <button
                className="wc-btnSecondary"
                onClick={() => navigate("/appointments")}
              >
                Schedule an evaluation
              </button>
            </div>
          </section>

          {/* BANNER */}
          <section className="wc-stripe">
            <div className="wc-banner">
              <img
                src="/content/workers-comp-pt/workerscomp_banner.png"
                alt="Bright physical therapy clinic for work injury care"
              />
              <div className="wc-bannerOverlay">
                <div className="wc-bannerText">
                  Recovering from a work injury can feel stressful—especially when you&apos;re worried about your job
                  and your pain at the same time. Physical therapy gives you a focused space to work on what your body
                  can do today, one visit at a time.
                </div>
                <div className="wc-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a workers’ comp visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* DISCLAIMER / SAFETY NOTE */}
          <section className="wc-stripe">
            <div className="wc-bottomStrip">
              <div className="wc-bottomText">
                This page is for general information only and is not legal advice, insurance advice, or a guarantee of coverage.
                <strong> Always confirm workers’ compensation details with your employer, insurer, case manager, or attorney.</strong>{" "}
                If you have red-flag symptoms—like chest pain, trouble breathing, new weakness, loss of bladder or bowel control,
                confusion, or severe pain—seek emergency medical care first. Physical therapy can then help support recovery once
                serious conditions are ruled out.
              </div>
              <div className="wc-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Book workers’ comp PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Contact our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default WorkersCompPT;
